import React, { useEffect, useState } from 'react';
import Input from '../ui/Input';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';

import countries from 'i18n-iso-countries';
import arLocale from 'i18n-iso-countries/langs/ar.json';
import enLocale from 'i18n-iso-countries/langs/en.json';
import { currencyCodes } from '../../constants/data';
import LocationPicker from '../dashboard/models/LocationPicker';
import { MdMyLocation } from 'react-icons/md';
import { fetchUser, stopEditing, updateUser } from '../../features/auth/userSlice';

countries.registerLocale(enLocale);
countries.registerLocale(arLocale);

const Profile = () => {
    const { t, i18n } = useTranslation();
    const { user, isEditing } = useSelector((state: RootState) => state.user);
    const [placeName, setPlaceName] = useState<string>("");
    const dispatch = useDispatch<AppDispatch>()
    const [showLocationPicker, setShowLocationPicker] = useState(false);
    const [formData, setFormData] = useState({
        id: user?.id || '',
        name: '',
        location: '',
        currency: '',
        latitude: undefined as number | undefined,
        longitude: undefined as number | undefined
    });
    useEffect(() => {
        if (user) {
            setFormData({
                id: user.id || '',
                name: user.name || '',
                location: user.location || '',
                currency: user.currencyCode || '',
                latitude: user.latitude,
                longitude: user.longitude
            });
        }
    }, [user, i18n.language]);

    const handleSave = () => {
        const formDataToSend = new FormData();
        formDataToSend.append("id", String(formData.id || ""));
        formDataToSend.append("name", formData.name);
        formDataToSend.append("location", formData.location);
        formDataToSend.append("currencyCode", formData.currency);
        formDataToSend.append("latitude", formData.latitude?.toString() || "");
        formDataToSend.append("longitude", formData.longitude?.toString() || "");
        if (!user?.id) return;
        dispatch(updateUser(formDataToSend))
            .unwrap()
            .then(() => {
                dispatch(fetchUser(user.id));
            })
            .catch((err) => {
                console.error("Update failed:", err);
            });
        dispatch(stopEditing());
    };

    const getCountryOptions = (lang: string) => {
        const countryNames = countries.getNames(lang as 'en' | 'ar', { select: 'official' });
        return Object.entries(countryNames).map(([code, name]) => ({
            value: code,
            label: name,
        }));
    };
    useEffect(() => {
        if (formData.latitude && formData.longitude) {
            fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${formData.latitude}&lon=${formData.longitude}&accept-language=ar`)
                .then(res => res.json())
                .then(data => {
                    if (data && data.display_name) {
                        setPlaceName(data.display_name);
                    } else {
                        setPlaceName("لم يتم العثور على الموقع");
                    }
                })
                .catch(() => setPlaceName("حدث خطأ أثناء جلب البيانات"));
        }
    }, [formData.latitude, formData.longitude]);
    return (
        <div className=" w-full  ">
            <h1 className=' text-xl mb-4 font-semibold'>{t("my-profile")}</h1>
            <div className="grid xs:grid-cols-1 sm:grid-cols-2 gap-4 ">
                <Input
                    value={formData.name}
                    onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                    type="text"
                    name="name"
                    text={t("name")}
                    required
                    disabled={!isEditing}
                />
                <Input
                    type="select"
                    name="location"
                    text={t("country")}
                    value={formData.location}
                    onChange={(e) => setFormData(prev => ({ ...prev, location: e.target.value }))}
                    required
                    disabled={!isEditing}
                    options={[
                        { value: '', label: " " },
                        ...getCountryOptions(i18n.language)
                    ]}
                />
                <Input
                    type="select"
                    name="currency"
                    text={t("currency")}
                    value={formData.currency}
                    onChange={(e) => setFormData(prev => ({ ...prev, currency: e.target.value }))}
                    required
                    disabled={!isEditing}
                    options={currencyCodes.map((c: string) => ({
                        value: c,
                        label: c
                    }))}
                />

                <div className="relative w-full flex flex-col gap-2">
                    <label className="font-medium text-lg">
                        {t("location")}
                    </label>
                    <button onClick={() => {
                        if (isEditing) {
                            setShowLocationPicker(true);
                        }
                    }} className="border flex-between w-full h-full border-grayColor rounded-lg px-2 py-3 bg-white focus:outline-none">
                        {placeName || t("place-not-marked")}
                        <MdMyLocation className=' text-secondry' />
                    </button>
                </div>
            </div>
            {/* أزرار التحكم */}
            <div className="mt-5">
                {isEditing &&
                    <>
                        <button
                            onClick={handleSave}
                            className="bg-primary text-white px-4 py-3 rounded-lg w-full"
                        >
                            {t("save")}
                        </button>

                    </>
                }
            </div>
            {showLocationPicker &&
                <div className="fixed inset-0 bg-black bg-opacity-30 justify-center p-5 flex z-50">
                    <div className="bg-white p-6 rounded-xl  max-h-[90vh] shadow-lg space-y-4 w-full max-w-2xl">
                        <LocationPicker
                            latitude={user?.latitude}
                            longitude={user?.longitude}
                            onChange={(coords) => setFormData((prev) => ({
                                ...prev,
                                latitude: coords.latitude,
                                longitude: coords.longitude,
                            }))}
                        />
                        <div className=' flex justify-end gap-5'>
                            <button onClick={() => setShowLocationPicker(false)} className="px-4 py-2  bg-grayColor text-black rounded">
                                {t("cancel")}
                            </button>
                            <button onClick={() => setShowLocationPicker(false)} className="px-4 py-2 bg-primary text-white rounded">
                                {t("save")}
                            </button>
                        </div>

                    </div>
                </div>
            }
        </div >
    );
};

export default Profile;
